"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _slicedToArray = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var hub_1 = require("./hub");

exports.connectToGaiaHub = hub_1.connectToGaiaHub;
exports.uploadToGaiaHub = hub_1.uploadToGaiaHub;
exports.BLOCKSTACK_GAIA_HUB_LABEL = hub_1.BLOCKSTACK_GAIA_HUB_LABEL; // export { type GaiaHubConfig } from './hub'

var ec_1 = require("../encryption/ec");

var keys_1 = require("../keys");

var profileLookup_1 = require("../profiles/profileLookup");

var errors_1 = require("../errors");

var userSession_1 = require("../auth/userSession");

var authConstants_1 = require("../auth/authConstants");

var utils_1 = require("../utils");

var fetchUtil_1 = require("../fetchUtil");

var etags = {};
var SIGNATURE_FILE_SUFFIX = '.sig';
/**
 * Fetch the public read URL of a user file for the specified app.
 * @param {String} path - the path to the file to read
 * @param {String} username - The Blockstack ID of the user to look up
 * @param {String} appOrigin - The app origin
 * @param {String} [zoneFileLookupURL=null] - The URL
 * to use for zonefile lookup. If falsey, this will use the
 * blockstack.js's [[getNameInfo]] function instead.
 * @return {Promise<string>} that resolves to the public read URL of the file
 * or rejects with an error
 */

function getUserAppFileUrl(path, username, appOrigin, zoneFileLookupURL) {
  return tslib_1.__awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var profile, bucketUrl, url, bucket;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return profileLookup_1.lookupProfile(username, zoneFileLookupURL);

          case 2:
            profile = _context.sent;
            bucketUrl = null;

            if (profile.hasOwnProperty('apps')) {
              if (profile.apps.hasOwnProperty(appOrigin)) {
                url = profile.apps[appOrigin];
                bucket = url.replace(/\/?(\?|#|$)/, '/$1');
                bucketUrl = "".concat(bucket).concat(path);
              }
            }

            return _context.abrupt("return", bucketUrl);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}

exports.getUserAppFileUrl = getUserAppFileUrl;
/**
 *
 *
 * @deprecated
 * #### v19 Use [[UserSession.encryptContent]].
 *
 * Encrypts the data provided with the app public key.
 * @param {String|Buffer} content - data to encrypt
 * @param {Object} [options=null] - options object
 * @param {String} options.publicKey - the hex string of the ECDSA public
 * key to use for encryption. If not provided, will use user's appPublicKey.
 * @return {String} Stringified ciphertext object
 */

function encryptContent(content, options, caller) {
  return tslib_1.__awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var opts, privateKey, wasString, contentBuffer, cipherObject, cipherPayload, signatureObject, signedCipherObject;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            opts = Object.assign({}, options);

            if (!opts.publicKey) {
              privateKey = (caller || new userSession_1.UserSession()).loadUserData().appPrivateKey;
              opts.publicKey = keys_1.getPublicKeyFromPrivate(privateKey);
            }

            if (typeof opts.wasString === 'boolean') {
              wasString = opts.wasString;
            } else {
              wasString = typeof content === 'string';
            }

            contentBuffer = typeof content === 'string' ? Buffer.from(content) : content;
            _context2.next = 6;
            return ec_1.encryptECIES(opts.publicKey, contentBuffer, wasString, opts.cipherTextEncoding);

          case 6:
            cipherObject = _context2.sent;
            cipherPayload = JSON.stringify(cipherObject);

            if (opts.sign) {
              if (typeof opts.sign === 'string') {
                privateKey = opts.sign;
              } else if (!privateKey) {
                privateKey = (caller || new userSession_1.UserSession()).loadUserData().appPrivateKey;
              }

              signatureObject = ec_1.signECDSA(privateKey, cipherPayload);
              signedCipherObject = {
                signature: signatureObject.signature,
                publicKey: signatureObject.publicKey,
                cipherText: cipherPayload
              };
              cipherPayload = JSON.stringify(signedCipherObject);
            }

            return _context2.abrupt("return", cipherPayload);

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
}

exports.encryptContent = encryptContent;
/**
 *
 * @deprecated
 * #### v19 Use [[UserSession.decryptContent]].
 *
 * Decrypts data encrypted with `encryptContent` with the
 * transit private key.
 * @param {String|Buffer} content - encrypted content.
 * @param {Object} [options=null] - options object
 * @param {String} options.privateKey - the hex string of the ECDSA private
 * key to use for decryption. If not provided, will use user's appPrivateKey.
 * @return {String|Buffer} decrypted content.
 */

function decryptContent(content, options, caller) {
  var opts = Object.assign({}, options);

  if (!opts.privateKey) {
    opts.privateKey = (caller || new userSession_1.UserSession()).loadUserData().appPrivateKey;
  }

  try {
    var cipherObject = JSON.parse(content);
    return ec_1.decryptECIES(opts.privateKey, cipherObject);
  } catch (err) {
    if (err instanceof SyntaxError) {
      throw new Error('Failed to parse encrypted content JSON. The content may not ' + 'be encrypted. If using getFile, try passing { decrypt: false }.');
    } else {
      throw err;
    }
  }
}

exports.decryptContent = decryptContent;
/* Get the gaia address used for servicing multiplayer reads for the given
 * (username, app) pair.
 * @private
 * @ignore
 */

function getGaiaAddress(app, username, zoneFileLookupURL, caller) {
  return tslib_1.__awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var opts, fileUrl, gaiaHubConfig, matches;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            opts = normalizeOptions({
              app: app,
              username: username,
              zoneFileLookupURL: zoneFileLookupURL
            }, caller);

            if (!username) {
              _context3.next = 7;
              break;
            }

            _context3.next = 4;
            return getUserAppFileUrl('/', opts.username, opts.app, opts.zoneFileLookupURL);

          case 4:
            fileUrl = _context3.sent;
            _context3.next = 14;
            break;

          case 7:
            if (!caller) {
              caller = new userSession_1.UserSession();
            }

            _context3.next = 10;
            return caller.getOrSetLocalGaiaHubConnection();

          case 10:
            gaiaHubConfig = _context3.sent;
            _context3.next = 13;
            return hub_1.getFullReadUrl('/', gaiaHubConfig);

          case 13:
            fileUrl = _context3.sent;

          case 14:
            matches = fileUrl.match(/([13][a-km-zA-HJ-NP-Z0-9]{26,35})/);

            if (matches) {
              _context3.next = 17;
              break;
            }

            throw new Error('Failed to parse gaia address');

          case 17:
            return _context3.abrupt("return", matches[matches.length - 1]);

          case 18:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
}
/**
 * @param {Object} [options=null] - options object
 * @param {String} options.username - the Blockstack ID to lookup for multi-player storage
 * @param {String} options.app - the app to lookup for multi-player storage -
 * defaults to current origin
 *
 * @ignore
 */


function normalizeOptions(options, caller) {
  var opts = Object.assign({}, options);

  if (opts.username) {
    if (!opts.app) {
      caller = caller || new userSession_1.UserSession();

      if (!caller.appConfig) {
        throw new errors_1.InvalidStateError('Missing AppConfig');
      }

      opts.app = caller.appConfig.appDomain;
    }

    if (!opts.zoneFileLookupURL) {
      caller = caller || new userSession_1.UserSession();

      if (!caller.appConfig) {
        throw new errors_1.InvalidStateError('Missing AppConfig');
      }

      if (!caller.store) {
        throw new errors_1.InvalidStateError('Missing store UserSession');
      }

      var sessionData = caller.store.getSessionData(); // Use the user specified coreNode if available, otherwise use the app specified coreNode. 

      var configuredCoreNode = sessionData.userData.coreNode || caller.appConfig.coreNode;

      if (configuredCoreNode) {
        opts.zoneFileLookupURL = "".concat(configuredCoreNode).concat(authConstants_1.NAME_LOOKUP_PATH);
      }
    }
  }

  return opts;
}
/**
 * @deprecated
 * #### v19 Use [[UserSession.getFileUrl]] instead.
 *
 * @param {String} path - the path to the file to read
 * @returns {Promise<string>} that resolves to the URL or rejects with an error
 */


function getFileUrl(path, options, caller) {
  return tslib_1.__awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    var opts, readUrl, gaiaHubConfig;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            opts = normalizeOptions(options, caller);

            if (!opts.username) {
              _context4.next = 7;
              break;
            }

            _context4.next = 4;
            return getUserAppFileUrl(path, opts.username, opts.app, opts.zoneFileLookupURL);

          case 4:
            readUrl = _context4.sent;
            _context4.next = 13;
            break;

          case 7:
            _context4.next = 9;
            return (caller || new userSession_1.UserSession()).getOrSetLocalGaiaHubConnection();

          case 9:
            gaiaHubConfig = _context4.sent;
            _context4.next = 12;
            return hub_1.getFullReadUrl(path, gaiaHubConfig);

          case 12:
            readUrl = _context4.sent;

          case 13:
            if (readUrl) {
              _context4.next = 17;
              break;
            }

            throw new Error('Missing readURL');

          case 17:
            return _context4.abrupt("return", readUrl);

          case 18:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
}

exports.getFileUrl = getFileUrl;
/* Handle fetching the contents from a given path. Handles both
 *  multi-player reads and reads from own storage.
 * @private
 * @ignore
 */

function getFileContents(path, app, username, zoneFileLookupURL, forceText, caller) {
  return tslib_1.__awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
    var opts, readUrl, response, contentType, etag;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            opts = {
              app: app,
              username: username,
              zoneFileLookupURL: zoneFileLookupURL
            };
            _context5.next = 3;
            return getFileUrl(path, opts, caller);

          case 3:
            readUrl = _context5.sent;
            _context5.next = 6;
            return fetchUtil_1.fetchPrivate(readUrl);

          case 6:
            response = _context5.sent;

            if (response.ok) {
              _context5.next = 11;
              break;
            }

            _context5.next = 10;
            return utils_1.getBlockstackErrorFromResponse(response, "getFile ".concat(path, " failed."), null);

          case 10:
            throw _context5.sent;

          case 11:
            contentType = response.headers.get('Content-Type');

            if (typeof contentType === 'string') {
              contentType = contentType.toLowerCase();
            }

            etag = response.headers.get('ETag');

            if (etag) {
              etags[path] = etag;
            }

            if (!(forceText || contentType === null || contentType.startsWith('text') || contentType.startsWith('application/json'))) {
              _context5.next = 19;
              break;
            }

            return _context5.abrupt("return", response.text());

          case 19:
            return _context5.abrupt("return", response.arrayBuffer());

          case 20:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
}
/* Handle fetching an unencrypted file, its associated signature
 *  and then validate it. Handles both multi-player reads and reads
 *  from own storage.
 * @private
 * @ignore
 */


function getFileSignedUnencrypted(path, opt, caller) {
  return tslib_1.__awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
    var sigPath, _yield$Promise$all, _yield$Promise$all2, fileContents, signatureContents, gaiaAddress, signature, publicKey, sigObject, signerAddress;

    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            // future optimization note:
            //    in the case of _multi-player_ reads, this does a lot of excess
            //    profile lookups to figure out where to read files
            //    do browsers cache all these requests if Content-Cache is set?
            sigPath = "".concat(path).concat(SIGNATURE_FILE_SUFFIX);
            _context6.prev = 1;
            _context6.next = 4;
            return Promise.all([getFileContents(path, opt.app, opt.username, opt.zoneFileLookupURL, false, caller), getFileContents(sigPath, opt.app, opt.username, opt.zoneFileLookupURL, true, caller), getGaiaAddress(opt.app, opt.username, opt.zoneFileLookupURL, caller)]);

          case 4:
            _yield$Promise$all = _context6.sent;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 3);
            fileContents = _yield$Promise$all2[0];
            signatureContents = _yield$Promise$all2[1];
            gaiaAddress = _yield$Promise$all2[2];

            if (fileContents) {
              _context6.next = 11;
              break;
            }

            return _context6.abrupt("return", fileContents);

          case 11:
            if (gaiaAddress) {
              _context6.next = 13;
              break;
            }

            throw new errors_1.SignatureVerificationError('Failed to get gaia address for verification of: ' + "".concat(path));

          case 13:
            if (!(!signatureContents || typeof signatureContents !== 'string')) {
              _context6.next = 15;
              break;
            }

            throw new errors_1.SignatureVerificationError('Failed to obtain signature for file: ' + "".concat(path, " -- looked in ").concat(path).concat(SIGNATURE_FILE_SUFFIX));

          case 15:
            _context6.prev = 15;
            sigObject = JSON.parse(signatureContents);
            signature = sigObject.signature;
            publicKey = sigObject.publicKey;
            _context6.next = 28;
            break;

          case 21:
            _context6.prev = 21;
            _context6.t0 = _context6["catch"](15);

            if (!(_context6.t0 instanceof SyntaxError)) {
              _context6.next = 27;
              break;
            }

            throw new Error('Failed to parse signature content JSON ' + "(path: ".concat(path).concat(SIGNATURE_FILE_SUFFIX, ")") + ' The content may be corrupted.');

          case 27:
            throw _context6.t0;

          case 28:
            signerAddress = keys_1.publicKeyToAddress(publicKey);

            if (!(gaiaAddress !== signerAddress)) {
              _context6.next = 33;
              break;
            }

            throw new errors_1.SignatureVerificationError("Signer pubkey address (".concat(signerAddress, ") doesn't") + " match gaia address (".concat(gaiaAddress, ")"));

          case 33:
            if (ec_1.verifyECDSA(fileContents, publicKey, signature)) {
              _context6.next = 37;
              break;
            }

            throw new errors_1.SignatureVerificationError('Contents do not match ECDSA signature: ' + "path: ".concat(path, ", signature: ").concat(path).concat(SIGNATURE_FILE_SUFFIX));

          case 37:
            return _context6.abrupt("return", fileContents);

          case 38:
            _context6.next = 47;
            break;

          case 40:
            _context6.prev = 40;
            _context6.t1 = _context6["catch"](1);

            if (!(_context6.t1 instanceof errors_1.DoesNotExist && _context6.t1.message.indexOf(sigPath) >= 0)) {
              _context6.next = 46;
              break;
            }

            throw new errors_1.SignatureVerificationError('Failed to obtain signature for file: ' + "".concat(path, " -- looked in ").concat(path).concat(SIGNATURE_FILE_SUFFIX));

          case 46:
            throw _context6.t1;

          case 47:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[1, 40], [15, 21]]);
  }));
}
/* Handle signature verification and decryption for contents which are
 *  expected to be signed and encrypted. This works for single and
 *  multiplayer reads. In the case of multiplayer reads, it uses the
 *  gaia address for verification of the claimed public key.
 * @private
 * @ignore
 */


function handleSignedEncryptedContents(caller, path, storedContents, app, privateKey, username, zoneFileLookupURL) {
  return tslib_1.__awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
    var appPrivateKey, appPublicKey, address, sigObject, signature, signerPublicKey, cipherText, signerAddress, decryptOpt;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            appPrivateKey = privateKey || caller.loadUserData().appPrivateKey;
            appPublicKey = keys_1.getPublicKeyFromPrivate(appPrivateKey);

            if (!username) {
              _context7.next = 8;
              break;
            }

            _context7.next = 5;
            return getGaiaAddress(app, username, zoneFileLookupURL, caller);

          case 5:
            address = _context7.sent;
            _context7.next = 9;
            break;

          case 8:
            address = keys_1.publicKeyToAddress(appPublicKey);

          case 9:
            if (address) {
              _context7.next = 11;
              break;
            }

            throw new errors_1.SignatureVerificationError('Failed to get gaia address for verification of: ' + "".concat(path));

          case 11:
            _context7.prev = 11;
            sigObject = JSON.parse(storedContents);
            _context7.next = 22;
            break;

          case 15:
            _context7.prev = 15;
            _context7.t0 = _context7["catch"](11);

            if (!(_context7.t0 instanceof SyntaxError)) {
              _context7.next = 21;
              break;
            }

            throw new Error('Failed to parse encrypted, signed content JSON. The content may not ' + 'be encrypted. If using getFile, try passing' + ' { verify: false, decrypt: false }.');

          case 21:
            throw _context7.t0;

          case 22:
            signature = sigObject.signature;
            signerPublicKey = sigObject.publicKey;
            cipherText = sigObject.cipherText;
            signerAddress = keys_1.publicKeyToAddress(signerPublicKey);

            if (!(!signerPublicKey || !cipherText || !signature)) {
              _context7.next = 30;
              break;
            }

            throw new errors_1.SignatureVerificationError('Failed to get signature verification data from file:' + " ".concat(path));

          case 30:
            if (!(signerAddress !== address)) {
              _context7.next = 34;
              break;
            }

            throw new errors_1.SignatureVerificationError("Signer pubkey address (".concat(signerAddress, ") doesn't") + " match gaia address (".concat(address, ")"));

          case 34:
            if (ec_1.verifyECDSA(cipherText, signerPublicKey, signature)) {
              _context7.next = 38;
              break;
            }

            throw new errors_1.SignatureVerificationError('Contents do not match ECDSA signature in file:' + " ".concat(path));

          case 38:
            if (!(typeof privateKey === 'string')) {
              _context7.next = 43;
              break;
            }

            decryptOpt = {
              privateKey: privateKey
            };
            return _context7.abrupt("return", caller.decryptContent(cipherText, decryptOpt));

          case 43:
            return _context7.abrupt("return", caller.decryptContent(cipherText));

          case 44:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, null, [[11, 15]]);
  }));
}
/**
 * Retrieves the specified file from the app's data store.
 * @param {String} path - the path to the file to read
 * @returns {Promise} that resolves to the raw data in the file
 * or rejects with an error
 */


function getFile(path, options, caller) {
  return tslib_1.__awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
    var defaults, opt, storedContents, decryptOpt, decryptionKey;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            defaults = {
              decrypt: true,
              verify: false,
              username: null,
              app: utils_1.getGlobalObject('location', {
                returnEmptyObject: true
              }).origin,
              zoneFileLookupURL: null
            };
            opt = Object.assign({}, defaults, options);

            if (!caller) {
              caller = new userSession_1.UserSession();
            } // in the case of signature verification, but no
            //  encryption expected, need to fetch _two_ files.


            if (!(opt.verify && !opt.decrypt)) {
              _context8.next = 5;
              break;
            }

            return _context8.abrupt("return", getFileSignedUnencrypted(path, opt, caller));

          case 5:
            _context8.next = 7;
            return getFileContents(path, opt.app, opt.username, opt.zoneFileLookupURL, !!opt.decrypt, caller);

          case 7:
            storedContents = _context8.sent;

            if (!(storedContents === null)) {
              _context8.next = 12;
              break;
            }

            return _context8.abrupt("return", storedContents);

          case 12:
            if (!(opt.decrypt && !opt.verify)) {
              _context8.next = 23;
              break;
            }

            if (!(typeof storedContents !== 'string')) {
              _context8.next = 15;
              break;
            }

            throw new Error('Expected to get back a string for the cipherText');

          case 15:
            if (!(typeof opt.decrypt === 'string')) {
              _context8.next = 20;
              break;
            }

            decryptOpt = {
              privateKey: opt.decrypt
            };
            return _context8.abrupt("return", caller.decryptContent(storedContents, decryptOpt));

          case 20:
            return _context8.abrupt("return", caller.decryptContent(storedContents));

          case 21:
            _context8.next = 35;
            break;

          case 23:
            if (!(opt.decrypt && opt.verify)) {
              _context8.next = 30;
              break;
            }

            if (!(typeof storedContents !== 'string')) {
              _context8.next = 26;
              break;
            }

            throw new Error('Expected to get back a string for the cipherText');

          case 26:
            if (typeof opt.decrypt === 'string') {
              decryptionKey = opt.decrypt;
            }

            return _context8.abrupt("return", handleSignedEncryptedContents(caller, path, storedContents, opt.app, decryptionKey, opt.username, opt.zoneFileLookupURL));

          case 30:
            if (!(!opt.verify && !opt.decrypt)) {
              _context8.next = 34;
              break;
            }

            return _context8.abrupt("return", storedContents);

          case 34:
            throw new Error('Should be unreachable.');

          case 35:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
}

exports.getFile = getFile;
/** @ignore */

var FileContentLoader = /*#__PURE__*/function () {
  function FileContentLoader(content, contentType) {
    _classCallCheck(this, FileContentLoader);

    this.wasString = typeof content === 'string';
    this.content = FileContentLoader.normalizeContentDataType(content, contentType);
    this.contentType = contentType || this.detectContentType();
    this.contentByteLength = this.detectContentLength();
  }

  _createClass(FileContentLoader, [{
    key: "detectContentType",
    value: function detectContentType() {
      if (this.wasString) {
        return 'text/plain; charset=utf-8';
      } else if (typeof Blob !== 'undefined' && this.content instanceof Blob && this.content.type) {
        return this.content.type;
      } else {
        return 'application/octet-stream';
      }
    }
  }, {
    key: "detectContentLength",
    value: function detectContentLength() {
      if (ArrayBuffer.isView(this.content) || Buffer.isBuffer(this.content)) {
        return this.content.byteLength;
      } else if (typeof Blob !== 'undefined' && this.content instanceof Blob) {
        return this.content.size;
      }

      var typeName = Object.prototype.toString.call(this.content);
      var error = new Error("Unexpected type \"".concat(typeName, "\" while detecting content length"));
      console.error(error);
      throw error;
    }
  }, {
    key: "loadContent",
    value: function loadContent() {
      return tslib_1.__awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var _this = this;

        var reader, readPromise, result, typeName, loadContentError;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;

                if (!Buffer.isBuffer(this.content)) {
                  _context9.next = 5;
                  break;
                }

                return _context9.abrupt("return", this.content);

              case 5:
                if (!ArrayBuffer.isView(this.content)) {
                  _context9.next = 9;
                  break;
                }

                return _context9.abrupt("return", Buffer.from(this.content.buffer, this.content.byteOffset, this.content.byteLength));

              case 9:
                if (!(typeof Blob !== 'undefined' && this.content instanceof Blob)) {
                  _context9.next = 18;
                  break;
                }

                reader = new FileReader();
                readPromise = new Promise(function (resolve, reject) {
                  reader.onerror = function (err) {
                    reject(err);
                  };

                  reader.onload = function () {
                    var arrayBuffer = reader.result;
                    resolve(Buffer.from(arrayBuffer));
                  };

                  reader.readAsArrayBuffer(_this.content);
                });
                _context9.next = 14;
                return readPromise;

              case 14:
                result = _context9.sent;
                return _context9.abrupt("return", result);

              case 18:
                typeName = Object.prototype.toString.call(this.content);
                throw new Error("Unexpected type ".concat(typeName));

              case 20:
                _context9.next = 28;
                break;

              case 22:
                _context9.prev = 22;
                _context9.t0 = _context9["catch"](0);
                console.error(_context9.t0);
                loadContentError = new Error("Error loading content: ".concat(_context9.t0));
                console.error(loadContentError);
                throw loadContentError;

              case 28:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this, [[0, 22]]);
      }));
    }
  }, {
    key: "load",
    value: function load() {
      if (this.loadedData === undefined) {
        this.loadedData = this.loadContent();
      }

      return this.loadedData;
    }
  }], [{
    key: "normalizeContentDataType",
    value: function normalizeContentDataType(content, contentType) {
      try {
        if (typeof content === 'string') {
          // If a charset is specified it must be either utf8 or ascii, otherwise the encoded content 
          // length cannot be reliably detected. If no charset specified it will be treated as utf8. 
          var charset = (contentType || '').toLowerCase().replace('-', '');

          if (charset.includes('charset') && !charset.includes('charset=utf8') && !charset.includes('charset=ascii')) {
            throw new Error("Unable to determine byte length with charset: ".concat(contentType));
          }

          if (typeof TextEncoder !== 'undefined') {
            var encodedString = new TextEncoder().encode(content);
            return Buffer.from(encodedString.buffer);
          }

          return Buffer.from(content);
        } else if (Buffer.isBuffer(content)) {
          return content;
        } else if (ArrayBuffer.isView(content)) {
          return Buffer.from(content.buffer, content.byteOffset, content.byteLength);
        } else if (typeof Blob !== 'undefined' && content instanceof Blob) {
          return content;
        } else if (typeof ArrayBuffer !== 'undefined' && content instanceof ArrayBuffer) {
          return Buffer.from(content);
        } else if (Array.isArray(content)) {
          // Provided with a regular number `Array` -- this is either an (old) method 
          // of representing an octet array, or a dev error. Perform basic check for octet array. 
          if (content.length > 0 && (!Number.isInteger(content[0]) || content[0] < 0 || content[0] > 255)) {
            throw new Error("Unexpected array values provided as file data: value \"".concat(content[0], "\" at index 0 is not an octet number. ").concat(this.supportedTypesMsg));
          }

          return Buffer.from(content);
        } else {
          var typeName = Object.prototype.toString.call(content);
          throw new Error("Unexpected type provided as file data: ".concat(typeName, ". ").concat(this.supportedTypesMsg));
        }
      } catch (error) {
        console.error(error);
        throw new Error("Error processing data: ".concat(error));
      }
    }
  }]);

  return FileContentLoader;
}();

FileContentLoader.supportedTypesMsg = 'Supported types are: `string` (to be UTF8 encoded), ' + '`Buffer`, `Blob`, `File`, `ArrayBuffer`, `UInt8Array` or any other typed array buffer. ';
/**
 * Determines if a gaia error response is possible to recover from
 * by refreshing the gaiaHubConfig, and retrying the request.
 */

function isRecoverableGaiaError(error) {
  if (!error || !error.hubError || !error.hubError.statusCode) {
    return false;
  }

  var statusCode = error.hubError.statusCode; // 401 Unauthorized: possible expired, but renewable auth token.

  if (statusCode === 401) {
    return true;
  } // 409 Conflict: possible concurrent writes to a file.


  if (statusCode === 409) {
    return true;
  } // 500s: possible server-side transient error


  if (statusCode >= 500 && statusCode <= 599) {
    return true;
  }

  return false;
}
/**
 * Stores the data provided in the app's data store to to the file specified.
 * @param {String} path - the path to store the data in
 * @param {String|Buffer} content - the data to store in the file
 * @return {Promise} that resolves if the operation succeed and rejects
 * if it failed
 */


function putFile(path, content, options, caller) {
  return tslib_1.__awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
    var _this2 = this;

    var defaults, opt, gaiaHubConfig, maxUploadBytes, hasMaxUpload, contentLoader, contentType, sizeErrMsg, sizeErr, encryptedSize, _sizeErrMsg, _sizeErr, etag, newFile, uploadFn, contentData, privateKey, signatureObject, signatureContent, contentForUpload, publicKey, _contentData, freshHubConfig;

    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            defaults = {
              encrypt: true,
              sign: false,
              cipherTextEncoding: 'hex'
            };
            opt = Object.assign({}, defaults, options);

            if (!caller) {
              caller = new userSession_1.UserSession();
            }

            _context12.next = 5;
            return caller.getOrSetLocalGaiaHubConnection();

          case 5:
            gaiaHubConfig = _context12.sent;
            maxUploadBytes = utils_1.megabytesToBytes(gaiaHubConfig.max_file_upload_size_megabytes);
            hasMaxUpload = maxUploadBytes > 0;
            contentLoader = new FileContentLoader(content, opt.contentType);
            contentType = contentLoader.contentType; // When not encrypting the content length can be checked immediately.

            if (!(!opt.encrypt && hasMaxUpload && contentLoader.contentByteLength > maxUploadBytes)) {
              _context12.next = 15;
              break;
            }

            sizeErrMsg = "The max file upload size for this hub is ".concat(maxUploadBytes, " bytes, the given content is ").concat(contentLoader.contentByteLength, " bytes");
            sizeErr = new errors_1.PayloadTooLargeError(sizeErrMsg, null, maxUploadBytes);
            console.error(sizeErr);
            throw sizeErr;

          case 15:
            if (!(opt.encrypt && hasMaxUpload)) {
              _context12.next = 22;
              break;
            }

            encryptedSize = ec_1.eciesGetJsonStringLength({
              contentLength: contentLoader.contentByteLength,
              wasString: contentLoader.wasString,
              sign: !!opt.sign,
              cipherTextEncoding: opt.cipherTextEncoding
            });

            if (!(encryptedSize > maxUploadBytes)) {
              _context12.next = 22;
              break;
            }

            _sizeErrMsg = "The max file upload size for this hub is ".concat(maxUploadBytes, " bytes, the given content is ").concat(encryptedSize, " bytes after encryption");
            _sizeErr = new errors_1.PayloadTooLargeError(_sizeErrMsg, null, maxUploadBytes);
            console.error(_sizeErr);
            throw _sizeErr;

          case 22:
            newFile = true;

            if (etags[path]) {
              newFile = false;
              etag = etags[path];
            }

            if (!(!opt.encrypt && opt.sign)) {
              _context12.next = 34;
              break;
            }

            _context12.next = 27;
            return contentLoader.load();

          case 27:
            contentData = _context12.sent;

            if (typeof opt.sign === 'string') {
              privateKey = opt.sign;
            } else {
              privateKey = caller.loadUserData().appPrivateKey;
            }

            signatureObject = ec_1.signECDSA(privateKey, contentData);
            signatureContent = JSON.stringify(signatureObject);

            uploadFn = function uploadFn(hubConfig) {
              return tslib_1.__awaiter(_this2, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
                var writeResponse;
                return _regeneratorRuntime.wrap(function _callee10$(_context10) {
                  while (1) {
                    switch (_context10.prev = _context10.next) {
                      case 0:
                        _context10.next = 2;
                        return Promise.all([hub_1.uploadToGaiaHub(path, contentData, hubConfig, contentType, newFile, etag), hub_1.uploadToGaiaHub("".concat(path).concat(SIGNATURE_FILE_SUFFIX), signatureContent, hubConfig, 'application/json')]);

                      case 2:
                        writeResponse = _context10.sent[0];

                        if (writeResponse.etag) {
                          etags[path] = writeResponse.etag;
                        }

                        return _context10.abrupt("return", writeResponse.publicURL);

                      case 5:
                      case "end":
                        return _context10.stop();
                    }
                  }
                }, _callee10);
              }));
            };

            _context12.next = 47;
            break;

          case 34:
            if (!(!opt.encrypt && !opt.sign)) {
              _context12.next = 38;
              break;
            }

            // If content does not need encrypted or signed, it can be passed directly 
            // to the fetch request without loading into memory. 
            contentForUpload = contentLoader.content;
            _context12.next = 46;
            break;

          case 38:
            // Use the `encrypt` key, otherwise the `sign` key, if neither are specified
            // then use the current user's app public key. 
            if (typeof opt.encrypt === 'string') {
              publicKey = opt.encrypt;
            } else if (typeof opt.sign === 'string') {
              publicKey = keys_1.getPublicKeyFromPrivate(opt.sign);
            } else {
              publicKey = keys_1.getPublicKeyFromPrivate(caller.loadUserData().appPrivateKey);
            }

            _context12.next = 41;
            return contentLoader.load();

          case 41:
            _contentData = _context12.sent;
            _context12.next = 44;
            return encryptContent(_contentData, {
              publicKey: publicKey,
              wasString: contentLoader.wasString,
              cipherTextEncoding: opt.cipherTextEncoding,
              sign: opt.sign
            });

          case 44:
            contentForUpload = _context12.sent;
            contentType = 'application/json';

          case 46:
            uploadFn = function uploadFn(hubConfig) {
              return tslib_1.__awaiter(_this2, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
                var writeResponse;
                return _regeneratorRuntime.wrap(function _callee11$(_context11) {
                  while (1) {
                    switch (_context11.prev = _context11.next) {
                      case 0:
                        _context11.next = 2;
                        return hub_1.uploadToGaiaHub(path, contentForUpload, hubConfig, contentType, newFile, etag);

                      case 2:
                        writeResponse = _context11.sent;

                        if (writeResponse.etag) {
                          etags[path] = writeResponse.etag;
                        }

                        return _context11.abrupt("return", writeResponse.publicURL);

                      case 5:
                      case "end":
                        return _context11.stop();
                    }
                  }
                }, _callee11);
              }));
            };

          case 47:
            _context12.prev = 47;
            _context12.next = 50;
            return uploadFn(gaiaHubConfig);

          case 50:
            return _context12.abrupt("return", _context12.sent);

          case 53:
            _context12.prev = 53;
            _context12.t0 = _context12["catch"](47);

            if (!isRecoverableGaiaError(_context12.t0)) {
              _context12.next = 66;
              break;
            }

            console.error(_context12.t0);
            console.error('Possible recoverable error during Gaia upload, retrying...');
            _context12.next = 60;
            return caller.setLocalGaiaHubConnection();

          case 60:
            freshHubConfig = _context12.sent;
            _context12.next = 63;
            return uploadFn(freshHubConfig);

          case 63:
            return _context12.abrupt("return", _context12.sent);

          case 66:
            throw _context12.t0;

          case 67:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12, null, [[47, 53]]);
  }));
}

exports.putFile = putFile;
/**
 * Deletes the specified file from the app's data store.
 * @param path - The path to the file to delete.
 * @param options - Optional options object.
 * @param options.wasSigned - Set to true if the file was originally signed
 * in order for the corresponding signature file to also be deleted.
 * @returns Resolves when the file has been removed or rejects with an error.
 */

function deleteFile(path, options, caller) {
  return tslib_1.__awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
    var gaiaHubConfig, opts, freshHubConfig, _freshHubConfig;

    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            if (!caller) {
              caller = new userSession_1.UserSession();
            }

            _context13.next = 3;
            return caller.getOrSetLocalGaiaHubConnection();

          case 3:
            gaiaHubConfig = _context13.sent;
            opts = Object.assign({}, options);

            if (!opts.wasSigned) {
              _context13.next = 24;
              break;
            }

            _context13.prev = 6;
            _context13.next = 9;
            return hub_1.deleteFromGaiaHub(path, gaiaHubConfig);

          case 9:
            _context13.next = 11;
            return hub_1.deleteFromGaiaHub("".concat(path).concat(SIGNATURE_FILE_SUFFIX), gaiaHubConfig);

          case 11:
            _context13.next = 22;
            break;

          case 13:
            _context13.prev = 13;
            _context13.t0 = _context13["catch"](6);
            _context13.next = 17;
            return caller.setLocalGaiaHubConnection();

          case 17:
            freshHubConfig = _context13.sent;
            _context13.next = 20;
            return hub_1.deleteFromGaiaHub(path, freshHubConfig);

          case 20:
            _context13.next = 22;
            return hub_1.deleteFromGaiaHub("".concat(path).concat(SIGNATURE_FILE_SUFFIX), gaiaHubConfig);

          case 22:
            _context13.next = 36;
            break;

          case 24:
            _context13.prev = 24;
            _context13.next = 27;
            return hub_1.deleteFromGaiaHub(path, gaiaHubConfig);

          case 27:
            _context13.next = 36;
            break;

          case 29:
            _context13.prev = 29;
            _context13.t1 = _context13["catch"](24);
            _context13.next = 33;
            return caller.setLocalGaiaHubConnection();

          case 33:
            _freshHubConfig = _context13.sent;
            _context13.next = 36;
            return hub_1.deleteFromGaiaHub(path, _freshHubConfig);

          case 36:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13, null, [[6, 13], [24, 29]]);
  }));
}

exports.deleteFile = deleteFile;
/**
 * Get the app storage bucket URL
 * @param {String} gaiaHubUrl - the gaia hub URL
 * @param {String} appPrivateKey - the app private key used to generate the app address
 * @returns {Promise} That resolves to the URL of the app index file
 * or rejects if it fails
 */

function getAppBucketUrl(gaiaHubUrl, appPrivateKey) {
  return hub_1.getBucketUrl(gaiaHubUrl, appPrivateKey);
}

exports.getAppBucketUrl = getAppBucketUrl;
/**
 * Loop over the list of files in a Gaia hub, and run a callback on each entry.
 * Not meant to be called by external clients.
 * @param {GaiaHubConfig} hubConfig - the Gaia hub config
 * @param {String | null} page - the page ID
 * @param {number} callCount - the loop count
 * @param {number} fileCount - the number of files listed so far
 * @param {function} callback - the callback to invoke on each file.  If it returns a falsey
 *  value, then the loop stops.  If it returns a truthy value, the loop continues.
 * @returns {Promise} that resolves to the number of files listed.
 * @private
 * @ignore
 */

function listFilesLoop(caller, hubConfig, page, callCount, fileCount, callback) {
  return tslib_1.__awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
    var response, pageRequest, fetchOptions, freshHubConfig, responseText, responseJSON, entries, nextPage, entriesLength, i, rc;
    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            if (!(callCount > 65536)) {
              _context14.next = 2;
              break;
            }

            throw new Error('Too many entries to list');

          case 2:
            _context14.t0 = hubConfig;

            if (_context14.t0) {
              _context14.next = 7;
              break;
            }

            _context14.next = 6;
            return caller.getOrSetLocalGaiaHubConnection();

          case 6:
            _context14.t0 = _context14.sent;

          case 7:
            hubConfig = _context14.t0;
            _context14.prev = 8;
            pageRequest = JSON.stringify({
              page: page
            });
            fetchOptions = {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Content-Length': "".concat(pageRequest.length),
                Authorization: "bearer ".concat(hubConfig.token)
              },
              body: pageRequest
            };
            _context14.next = 13;
            return fetchUtil_1.fetchPrivate("".concat(hubConfig.server, "/list-files/").concat(hubConfig.address), fetchOptions);

          case 13:
            response = _context14.sent;

            if (response.ok) {
              _context14.next = 18;
              break;
            }

            _context14.next = 17;
            return utils_1.getBlockstackErrorFromResponse(response, 'ListFiles failed.', hubConfig);

          case 17:
            throw _context14.sent;

          case 18:
            _context14.next = 28;
            break;

          case 20:
            _context14.prev = 20;
            _context14.t1 = _context14["catch"](8);

            if (!(callCount === 0)) {
              _context14.next = 27;
              break;
            }

            _context14.next = 25;
            return caller.setLocalGaiaHubConnection();

          case 25:
            freshHubConfig = _context14.sent;
            return _context14.abrupt("return", listFilesLoop(caller, freshHubConfig, page, callCount + 1, 0, callback));

          case 27:
            throw _context14.t1;

          case 28:
            _context14.next = 30;
            return response.text();

          case 30:
            responseText = _context14.sent;
            responseJSON = JSON.parse(responseText);
            entries = responseJSON.entries;
            nextPage = responseJSON.page;

            if (!(entries === null || entries === undefined)) {
              _context14.next = 36;
              break;
            }

            throw new Error('Bad listFiles response: no entries');

          case 36:
            entriesLength = 0;
            i = 0;

          case 38:
            if (!(i < entries.length)) {
              _context14.next = 47;
              break;
            }

            if (!(entries[i] !== null)) {
              _context14.next = 44;
              break;
            }

            entriesLength++;
            rc = callback(entries[i]);

            if (rc) {
              _context14.next = 44;
              break;
            }

            return _context14.abrupt("return", fileCount + i);

          case 44:
            i++;
            _context14.next = 38;
            break;

          case 47:
            if (!(nextPage && entries.length > 0)) {
              _context14.next = 51;
              break;
            }

            return _context14.abrupt("return", listFilesLoop(caller, hubConfig, nextPage, callCount + 1, fileCount + entriesLength, callback));

          case 51:
            return _context14.abrupt("return", fileCount + entriesLength);

          case 52:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14, null, [[8, 20]]);
  }));
}
/**
 * List the set of files in this application's Gaia storage bucket.
 * @param {function} callback - a callback to invoke on each named file that
 * returns `true` to continue the listing operation or `false` to end it
 * @return {Promise} that resolves to the total number of listed files.
 * If the call is ended early by the callback, the last file is excluded.
 * If an error occurs the entire call is rejected.
 */


function listFiles(callback, caller) {
  caller = caller || new userSession_1.UserSession();
  return listFilesLoop(caller, null, null, 0, 0, callback);
}

exports.listFiles = listFiles;